module.exports = new __parcel__URL__("quake-4.de0d9612.jpg").toString();